// ABOUTME: Opening the app (any page, web or the mobile shell) or coming back to it wakes the
// business's agent machine once, so Hermes runs the cron jobs that came due while it slept
// (app/api/v1/agent/app_open.py). Nothing wakes it on a timer.

import { useEffect } from 'react'
import { appOpened } from '@/api/agent'

export function useAppOpenWake() {
  useEffect(() => {
    let away = true
    const onVisibility = () => {
      if (document.visibilityState !== 'visible') {
        away = true
      } else if (away) {
        away = false
        void appOpened().catch(() => undefined)
      }
    }
    onVisibility()
    document.addEventListener('visibilitychange', onVisibility)
    return () => document.removeEventListener('visibilitychange', onVisibility)
  }, [])
}
